import { LocaleSelector } from '@tix-ticketing/ui-components';
import { FormattedMessage, useIntl } from 'react-intl';
import type { CurrencyRatesResponse } from 'api/generated';
import { useAppState } from 'lib/app-state';
import { currencyLongName, currencySymbol } from 'lib/helpers/formatted-price';
import { localeName } from 'messages';
import type { Locale, LocaleKey } from 'messages';
export function LanguageSelector({
  locales,
  currencies,
  selectedLocale,
  selectedCurrency,
  onLocaleChange,
  onCurrencyChange
}: {
  locales: Locale[];
  currencies: CurrencyRatesResponse;
  selectedLocale: LocaleKey;
  selectedCurrency: string;
  onLocaleChange(locale: LocaleKey): void;
  onCurrencyChange(currency: string): void;
}) {
  const {
    locale
  } = useAppState();
  const intl = useIntl();
  return <LocaleSelector label={intl.formatMessage({
    id: "common.languageAndCurrency",
    defaultMessage: [{
      "type": 0,
      "value": "Language & currency"
    }]
  })} triggerLabel={localeName(selectedLocale)} triggerMeta={selectedCurrency} tabs={[{
    label: <FormattedMessage id="account.settings.language" defaultMessage={[{
      "type": 0,
      "value": "Language"
    }]} />,
    options: locales.map(l => ({
      value: l.countryCode,
      title: l.language,
      subtitle: l.country
    })),
    selected: selectedLocale,
    onSelect: value => onLocaleChange(value as LocaleKey)
  }, {
    label: <FormattedMessage id="account.settings.currency" defaultMessage={[{
      "type": 0,
      "value": "Currency"
    }]} />,
    options: (currencies.currencyRates ?? []).map(currency => ({
      value: currency.currencyKey ?? 'USD',
      title: <>
                {currency.currencyKey} &bull;{' '}
                {currency.currencyKey && currencySymbol(currency.currencyKey, locale)}
              </>,
      subtitle: currency.currencyKey && currencyLongName(currency.currencyKey, locale)
    })),
    selected: selectedCurrency,
    onSelect: onCurrencyChange
  }]} />;
}